import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Extra content rendered to the right of the title (e.g. action buttons) */
  action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => (
  <div className={`${action ? 'flex justify-between items-start' : ''} mb-8 animate-fade-up`}>
    <div>
      <h1
        className="text-3xl sm:text-4xl font-extrabold tracking-tight"
        style={{ color: 'var(--text-primary)', letterSpacing: '-0.025em' }}
      >
        {title}
      </h1>
      {subtitle && (
        <p className="mt-1 text-sm" style={{ color: 'var(--text-muted)' }}>
          {subtitle}
        </p>
      )}
    </div>
    {action}
  </div>
);

export default PageHeader;
